'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _formFieldUtils = require('../../formFieldUtils');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatIn(value) {
  if (!Array.isArray(value) || (0, _lodash.isEmpty)(value)) {
    return [];
  }
  return value.map(function (item) {
    return {
      name: item.name,
      fileName: item.name,
      state: 'done',
      downloadURL: item.url,
      url: item.url,
      uid: item.uid
    };
  });
}

function formatOut(value) {
  if (!Array.isArray(value) || (0, _lodash.isEmpty)(value)) {
    return value;
  }
  return value.filter(function (item) {
    return item.state !== 'error';
  }).map(function (item) {
    return (0, _lodash.pick)(item, ['name', 'url', 'height', 'width', 'uid']);
  });
}

function defaultValueFormatter(value) {
  if (!Array.isArray(value) || (0, _lodash.isEmpty)(value)) {
    return '';
  }
  return value.map(function (item) {
    return _react2.default.createElement(
      'a',
      {
        key: (0, _formFieldUtils.uuid)(),
        href: item.url,
        title: item.name,
        target: '_blank',
        style: { display: 'block', wordBreak: 'break-all' }
      },
      item.name,
      '\xA0'
    );
  });
}

exports.default = {
  formatIn: formatIn,
  formatOut: formatOut,
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];